export default __webpack_public_path__ + "static/media/aqua.4fc8ca44.png";